export const isInboxEnabled = () => false

export const getReviewRoute = (itemId = null) => {
  let baseRoute = "/inbox/"
  if (itemId) baseRoute += `${itemId}/`
  return baseRoute
}
